export default __webpack_public_path__ + "static/media/cereal-pour.b8090e5c.mp3";